import React from 'react';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { S3_ASSETS_PATH } from '../../../../../constants';

const BrandNotFound: React.FC = () => {
  return (
    <section className="page-not-found-section" data-testid="brandNotFound">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className="page-not-found-container"
        style={{ minHeight: '89vh' }}
      >
        <div className="page-not-found-wrapper">
          <img src={`${S3_ASSETS_PATH}/images/404.svg`} alt="404-page-bg" />
          <div className="content-blk text-center">
            <h3 className="paragraph">OOPS</h3>
            <p className="paragraph">
              we can't seem to find the brand you're looking for{' '}
            </p>
            <Link
              className="primary-btn"
              to="/"
              data-testid="brandNotFoundBackHomeButton"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </Grid>
    </section>
  );
};

export default BrandNotFound;
